export class UpdatePieceIndividual 
{
    individualId: number|undefined;
    typePiece : String;
    dateExpPiece : String;
    dateNaissance : String;
    lieuNaissance : String;
}